import React, { Component } from "react";
import Slider from "react-slick";

//IMPORT IMAGES
import teacherPlaceholderImg from '../../frontend/assets/img/Jainism/teacher-placeholder.jpg';
import beforeShapeImg from '../../frontend/assets/img/shape/before-shape-2.png';
import afterShapeImg from '../../frontend/assets/img/shape/after-shape-2.png';
import cloud1Img from '../../frontend/assets/img/shape/cloud-1.png';
import cloud2Img from '../../frontend/assets/img/shape/cloud-2.png';
import teacherVectorImg from '../../frontend/assets/img/Jainism/teacher  new svg.svg';
import blackboardVectorImg from '../../frontend/assets/img/Jainism/black board svg.svg';

class Team extends Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }


    render() {
        function SampleNextArrow(props) {
            const { onClick } = props;
            return (
                <button onClick={onClick} type="button" className="slick-prev slick-arrow" ><i className="fal fa-arrow-left"></i></button>
            );
        }

        function SamplePrevArrow(props) {
            const { onClick } = props;
            return (
                <button onClick={onClick} type="button" className="slick-next slick-arrow" ><i className="fal fa-arrow-right"></i></button>
            );
        }
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            initialSlide: 0,
            waitForAnimate: false,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <section className="process-section bg-smoke-blue space-extra">
                    <div className="container">
                        <div className="title-area text-center wow fadeInUp" data-wow-delay="0.1s">
                            <span className="sub-title">Our Teachers</span>
                            <h2 className="sec-title">Expert Mentors</h2>
                        </div>
                        <div className="row vs-carousel" data-slide-show="3" data-arrows="true">
                            <Slider {...settings}>
                                <div className="col-lg-4 col-md-6 wow fadeInUp px-3" data-wow-delay="0.1s">
                                    <div className="team-box">
                                        <div className="team-img">
                                            <img src={teacherPlaceholderImg} alt="team" />

                                        </div>
                                        <div className="team-info">
                                            <h4 className="team-title"><a href="#">Teacher Name</a></h4>
                                            <span className="team-desig">Mentor</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 wow fadeInUp px-3" data-wow-delay="0.1s">
                                    <div className="team-box">
                                        <div className="team-img">
                                            <img src={teacherPlaceholderImg} alt="team" />

                                        </div>
                                        <div className="team-info">
                                            <h4 className="team-title"><a href="#">Teacher Name</a></h4>
                                            <span className="team-desig">Designation</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 wow fadeInUp px-3" data-wow-delay="0.1s">
                                    <div className="team-box">
                                        <div className="team-img">
                                            <img src={teacherPlaceholderImg} alt="team" />

                                        </div>
                                        <div className="team-info">
                                            <h4 className="team-title"><a href="#">Teacher Name</a></h4>
                                            <span className="team-desig">Designation</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 wow fadeInUp px-3" data-wow-delay="0.1s">
                                    <div className="team-box">
                                        <div className="team-img">
                                            <img src={teacherPlaceholderImg} alt="team" />

                                        </div>
                                        <div className="team-info">
                                            <h4 className="team-title"><a href="#">Teacher Name</a></h4>
                                            <span className="team-desig">Designation</span>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <div className="shape-before"><img src={beforeShapeImg} alt="shape" /></div>
                    <div className="shape-after"><img src={afterShapeImg} alt="shape" /></div>
                    <div className="shape-mockup z-index-3 d-none d-lg-block" data-top="-18%" data-right="0%"><img
                        src={cloud1Img} alt="shapes" /></div>
                    <div className="shape-mockup z-index-3 d-none d-lg-block" data-bottom="-11%" data-left="0%"><img
                        src={cloud2Img} alt="shapes" /></div>

                    <div className="shape-mockup shapePulse d-none d-hd-block teacher-vector" data-top="5%" data-left="6%"
                        style={{ width: "15%" }}><img src={teacherVectorImg} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse d-none d-hd-block blackboard-vector" data-top="30%" data-right="6%"><img
                        src={blackboardVectorImg} alt="shapes" /></div>
                </section>
            </React.Fragment >
        );
    }
}

export default Team;
